<template>
  <Chart :options="options" />
</template>

<script>
import data from "./assets/data.json";
import { Chart } from "highcharts-vue";
import ChartOptions from "@international-energy-agency/vue-ui/highcharts";
export default {
  name: "App",
  components: {
    Chart,
  },
  data() {
    return {
      data,
    };
  },
  computed: {
    series() {
      const { data } = this;
      const nodes = [];
      const columns = ["Battery", "Production", "Registration"];
      const rowOrder = [
        "China",
        "Europe",
        "North America",
        "Japan",
        "South Korea",
        "Rest of world",
      ];

      data.sort(function (a, b) {
        if (rowOrder.indexOf(a.from) === rowOrder.indexOf(b.from)) {
          return rowOrder.indexOf(a.to) - rowOrder.indexOf(b.to);
        }
        return rowOrder.indexOf(a.from) - rowOrder.indexOf(b.from);
      });

      const formattedData = data.map((d) => ({
        from: `${d.from}-${d.type}`,
        to: `${d.to}-${d.type === "Battery" ? "Production" : "Registration"}`,
        weight: d.value,
      }));

      const unique = data
        .filter((d, i, a) => a.findIndex((t) => t.from === d.from) === i)
        .map((d) => d.from);

      unique.forEach((item, i) => {
        columns.forEach((col) => {
          nodes.push({ id: `${item}-${col}`, name: item, colorIndex: i });
        });
      });
      return [
        {
          keys: ["from", "to", "weight", "id"],
          nodes: nodes,
          data: formattedData,
          type: "sankey",
        },
      ];
    },
    options() {
      const { series } = this;
      return ChartOptions.buildOptions({
        series,
        chart: {
          events: {
            render: function () {
              const positions = [30, this.chartWidth / 2, this.chartWidth - 30];

              if (this.customLabels) {
                this.customLabels.forEach((customLabel, i) => {
                  customLabel.attr({
                    x: positions[i],
                    y: this.chartHeight - 20,
                  });
                });
              } else {
                this.customLabels = [];
                ["Battery", "Production", "Registration"].forEach(
                  (label, i) => {
                    this.customLabels.push(
                      this.renderer
                        .text(["Battery", "Production", "Registration"][i])
                        .attr({
                          x: positions[i],
                          y: 20,
                          align: "center",
                        })
                        .css({
                          fontSize: "12px",
                          fontWeight: 600,
                        })
                        .add()
                    );
                  }
                );
              }
            },
          },
        },
        tooltip: {
          valueSuffix: " GWh",
          valueDecimals: 2,
          headerFormat: "",
          nodeFormat: "{point.name}: <b>{point.sum:.2f} GWh</b>",
        },
        dataLabels: {
          overflow: "allow",
          crop: true,
          enabled: true,
          formatter: function () {
            return this.point.weight;
          },
        },
      });
    },
  },
};
</script>

<style></style>
